// src/components/ReadingProgress.jsx
import React from 'react';
import styled from 'styled-components';

const ProgressBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: rgba(176, 141, 87, 0.2);
  z-index: 1000;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: var(--primary);
    width: ${props => props.progress}%;
    transition: width 0.1s ease;
  }
`;

const ScrollToTop = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--primary);
  color: var(--primaryFg);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  box-shadow: 0 4px 12px rgba(176, 141, 87, 0.3);
  transition: all 0.3s ease;
  z-index: 999;
  
  opacity: ${props => props.visible ? 1 : 0};
  transform: translateY(${props => props.visible ? 0 : 20}px);
  pointer-events: ${props => props.visible ? 'auto' : 'none'};
  
  &:hover {
    transform: translateY(${props => props.visible ? -2 : 20}px);
    box-shadow: 0 6px 20px rgba(176, 141, 87, 0.4);
  }
  
  @media (max-width: 768px) {
    bottom: 16px;
    right: 16px;
    width: 44px;
    height: 44px;
    font-size: 18px;
  }
`;

export default function ReadingProgress() {
  const [progress, setProgress] = React.useState(0);
  const [showScrollTop, setShowScrollTop] = React.useState(false);
  
  React.useEffect(() => {
    const updateProgress = () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;
      
      setProgress(Math.min(100, Math.max(0, scrollPercent)));
      setShowScrollTop(scrollTop > 300);
    };
    
    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress(); // Инициализация
    
    return () => window.removeEventListener('scroll', updateProgress);
  }, []);
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <>
      <ProgressBar progress={progress} />
      <ScrollToTop 
        visible={showScrollTop} 
        onClick={scrollToTop}
        aria-label="Наверх"
        title="Наверх"
      >
        ↑
      </ScrollToTop>
    </>
  );
}